import { render, staticRenderFns } from "./ListProgettiOperatore.vue?vue&type=template&id=2a961290&"
import script from "./ListProgettiOperatore.vue?vue&type=script&lang=js&"
export * from "./ListProgettiOperatore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports